import React, { useContext } from 'react'
import { openUserProfile } from '$logic/router'
import { UserListItem } from '$common/user-list-item'
import { addToRecentSearch } from '$logic/room-list/room-list-search.service'
import { ForwardSearchQueryContext } from '$comp/_app/components/leftPanel/components/forward-list'
import { WithQueryUserListItemTitle } from './with-query-user-list-item-title'
import { WithQueryUserListItemStatus } from './with-query-user-list-item-status'

interface Props {
  userId: string
  hasDivider?: boolean
}

export function SearchedUserListItemWithStatus({ userId, hasDivider }: Props) {
  const searchQuery = useContext(ForwardSearchQueryContext)
  return (
    <UserListItem
      userId={userId}
      primaryText={
        <WithQueryUserListItemTitle userId={userId} query={searchQuery} />
      }
      secondaryText={
        <WithQueryUserListItemStatus userId={userId} query={searchQuery} />
      }
      hasDivider={hasDivider}
      onClick={() => {
        if (!userId) return
        openUserProfile(userId)
        addToRecentSearch({ type: 'USER', id: userId })
      }}
    />
  )
}
